export default __webpack_public_path__ + "static/media/calamari.f74c5239.png";